<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'printOrderInvoice' })"
      @prev-step="$router.push({ name: 'printOrder' })"
    ></next-prev-menu>

    <deliver-pickup
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      :secure="orderDetails.secure"
      @updateOrder="updateOrder"
    ></deliver-pickup>
  </div>
</template>

<script>
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import DeliverPickup from '@/components/DeliverPickup.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    DeliverPickup
  },
  computed: {
    printOrderStore() {
      return usePrintOrderStore()
    },
    orderDetails() {
      return this.printOrderStore.orderDetails
    },
    shop() {
      return this.printOrderStore.shop
    },
    dates() {
      return this.printOrderStore.dates
    }
  },
  methods: {
    updateOrder(val) {
      this.printOrderStore.updateOrderDetails(val[0], val[1])
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
